<template>
	<section>
		<img src="img/group-31.png" alt="Bisa Cek" class="dot group-31 hide-on-mobile">                            
		<div id="login">
			<hr class="path ml-5 hide-on-mobile">
			<ValidationObserver tag="form" v-slot="{ invalid }" onsubmit="return false" class="mx-auto w-m-80 w-30">
				<img src="/img/Logo.png" alt="Bisa Cek" class="group-2 mx-auto d-block img-fluid" style="width: 70%">

				<div class="alert alert-danger text-center f-14" v-if="authFalse">
					{{ message == null ? "Masuk gagal, periksa kembali email atau kata sandi anda." : message }}
				</div>

				<ValidationProvider name="email" rules="required|email">
					<div class="form-group" slot-scope="{ errors }">
						<label class="form-label">Email</label>
						<input type="email" v-model="email" class="form-control" :class="{ 'error': errors[0] || authFalse }" placeholder="Masukkan email">
						<div class="error-alert">{{ errors[0] }}</div>
					</div>
				</ValidationProvider>

				<ValidationProvider name="password" rules="required">
					<div class="form-group" slot-scope="{ errors }">
						<label class="form-label">Password</label>
						<div class="input-group" :class="{ 'error': errors[0] || authFalse }" id="show_hide_password">
							<input type="password" v-model="password" class="form-control append-button" placeholder="Masukkan kata sandi">
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-eye-slash" aria-hidden="true"></i>
								</span>
							</div>
						</div>
						<div class="error-alert">{{ errors[0] }}</div>
					</div>
				</ValidationProvider>
				<div class="float-right mb-1">
					<router-link tag="a" class="link" to="lupa-password">Lupa kata sandi?</router-link>
				</div>
				<button :disabled="invalid" @click="login" class="btn btn-primary w-full pd-10-20">Masuk</button>
			</ValidationObserver>
		</div>
	</section>
	
</template>

<script>
import $ from 'jquery'
export default {
	name: 'Login',
	data() {
		return {
			'email': null,
			'password': null,
			'authFalse': false,
			message: null
		}
	},
	methods: {
		login() {
			let _ = this
			_.axios.post('/auth/login', { email: _.email, password: _.password})
				.then(resp=>{		
					if(resp.data.detail.status == 1){			
						if(resp.data.detail.role == 1 || resp.data.detail.role == 2){
							_.$store.dispatch('login', resp.data)
							if ( resp.data ) {
								_.$router.push('/dashboard')
							} else {
								_.authFalse = true
							}
						} else {
							_.authFalse = true
						}
					} else {
						_.authFalse = true
						_.message = "Masuk gagal, akun anda dinonaktifkan."
					}                    
				})
				.catch(err=>{
                    console.log(err.message)
                    _.authFalse = true
				})
		}
	},
	mounted() {
		$("#show_hide_password span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password input').attr("type") == "text"){
	            $('#show_hide_password input').attr('type', 'password');
	            $('#show_hide_password i').addClass( "fa-eye-slash" );
	            $('#show_hide_password i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password input').attr("type") == "password"){
	            $('#show_hide_password input').attr('type', 'text');
	            $('#show_hide_password i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password i').addClass( "fa-eye" );
	        }
		});
		
		if (localStorage.getItem('token')){
			this.$router.push('/dashboard')
		}
	}
}
</script>